import { render, staticRenderFns } from "./GoldschmiedePage.vue?vue&type=template&id=c5c01756&scoped=true&"
import script from "./GoldschmiedePage.vue?vue&type=script&lang=js&"
export * from "./GoldschmiedePage.vue?vue&type=script&lang=js&"
import style0 from "./GoldschmiedePage.vue?vue&type=style&index=0&id=c5c01756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c01756",
  null
  
)

export default component.exports